// extracted by mini-css-extract-plugin
export default {"entryContainer":"dashboard_entryContainer__CPcl+","btn":"dashboard_btn__J-5HL"};